import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const UserIcon = (props) => {
    return (
        <SvgIcon width="19" height="22" viewBox="0 0 19.495 22.995" fontSize='small'>
            <g  transform="translate(-1104 -9.188)">
                <g  transform="translate(1105 10.188)">
                    <path d="M66,56a5,5,0,1,1-5-5A5,5,0,0,1,66,56Z" transform="translate(-52.251 -51)" fill="none" stroke="var(--primary)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    <path d="M61.748,62A8.748,8.748,0,0,0,53,70.748H70.5A8.748,8.748,0,0,0,61.748,62Z" transform="translate(-53 -49.753)" fill="none" stroke="var(--primary)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                </g>
            </g>

        </SvgIcon>
    );
};

export default UserIcon;
